<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="mt-1 mb-3">Usuário</h5>
            <usuario-detalhe v-if="tipo==='confirmados'"></usuario-detalhe>
            <usuario-temp-detalhe v-if="tipo==='aguardando'"></usuario-temp-detalhe>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import UsuarioDetalhe from "@/router/views/admin/components/usuario-detalhe";
import UsuarioTempDetalhe from "@/router/views/admin/components/usuario_temp-detalhe";

export default {
  page: {
    title: "Guias",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    UsuarioDetalhe,
    UsuarioTempDetalhe
  },
  created() {
    if (this.$route.params.tipo) {
      this.tipo = this.$route.params.tipo;
    }
  },
  data() {
    return {
      title: "Detalhe",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Usuários',
          href: '/admin/pessoas/usuarios',
        },
        {
          text: 'Detalhe',
          active: true,
        },
      ],
      tipo: ''
    };
  },
};
</script>


